export enum FP_VOUCHER_TYPES {
    FreeSpin =  '1',
    FreePlay = '2',
    FreeJackpotSpin = '3',
    FreeJackpotPlay = '4'
}

export const FP_MESSAGE_MODE = {
    POPUP: 'popup',
    EMBEDDED_INTERNAL: 'embedded-internal'
};
